import { InlinePromptButtons } from "./prompt-suggestions"

interface PromptButtonsMessageProps {
  label?: string
  suggestions: string[]
  onSelectPrompt: (prompt: string) => void
}

export function PromptButtonsMessage({
  label,
  suggestions,
  onSelectPrompt,
}: PromptButtonsMessageProps) {
  return (
    <div className="w-full">
      <InlinePromptButtons
        label={label}
        suggestions={suggestions}
        onSelectPrompt={onSelectPrompt}
      />
    </div>
  )
}

